export default __webpack_public_path__ + "static/media/Avatar-2.516ef513.png";